import { render } from "./RecycleScroller.vue?vue&type=template&id=2a0d9670"
import script from "./RecycleScroller.vue?vue&type=script&lang=js"
export * from "./RecycleScroller.vue?vue&type=script&lang=js"

import "./RecycleScroller.vue?vue&type=style&index=0&id=2a0d9670&lang=css"
script.render = render

export default script